// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__4Ouzn","actionsCol":"EnrolledClinics_actionsCol__2H939"};